import gsap from 'gsap';

class Counter {
    constructor({ element }) {
        this.element = element;
    }

    init() {
        this.element.addEventListener( 'CallEvent', ( e ) => {
            this.animate();
        } );
    }

    animate() {
		var dec = Math.floor( $( this.element ).data( 'dec' ) ) || 0;
        $( this.element ).prop( 'Counter', ( $( this.element ).data( 'number' ) - 10 ) ).animate( {
            Counter: $( this.element ).data( 'number' )
        }, {
            duration: 1500,
            easing: 'swing',
            step: function ( now ) {
                $( this ).text( Math.round( now * 1 ) );
            }
        });
    }
}

export default function () {
    document.querySelectorAll( '[data-scroll-call="counter"]' ).forEach( ( element ) => {
        let counter = new Counter( { element } );
        setTimeout( () => {
            counter.init();
        }, 500 );
    } );
}